import useIframeFeaturesEnabled from 'hooks/meta/useIframeFeaturesEnabled';
import { useReduxSelector } from '.';

export default function useIsInIframe() {
  const areIframeFeaturesEnabled = useIframeFeaturesEnabled();
  return useReduxSelector((state) => state.iframe.isInIframe) && areIframeFeaturesEnabled;
}
